import { editorials } from "@/mocks/homeContent";

export default function FeatureEditorials() {
  return (
    <section id="feature" className="scroll-mt-16 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-8">
        <div className="text-center">
          <p className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-900">
            <i className="ri-book-open-line" aria-hidden="true" />
            编辑部专栏
          </p>
          <h2 className="mt-3 font-heading text-3xl font-semibold text-foreground-950 md:text-4xl">
            深读话题 · 说给你听
          </h2>
          <p className="mx-auto mt-2 max-w-2xl text-sm text-foreground-600 md:text-base">
            不只吃瓜，也聊聊那些藏在日常背后的校园情绪与思考。
          </p>
        </div>

        <div className="mt-9 flex flex-col gap-7">
          {editorials.map((e, idx) => {
            const flip = idx % 2 === 1;
            return (
              <article
                key={e.id}
                className="grid grid-cols-1 items-center gap-6 overflow-hidden rounded-3xl border border-background-200 bg-background-50 md:grid-cols-2 md:gap-8"
              >
                <div
                  className={`relative h-56 w-full overflow-hidden md:h-80 ${
                    flip ? "md:order-2" : ""
                  }`}
                >
                  <img
                    src={e.image}
                    alt={`专栏配图：${e.title}`}
                    className="h-full w-full object-cover"
                  />
                  <span className="absolute left-4 top-4 rounded-full bg-accent-500 px-3 py-1 text-xs font-medium text-foreground-950">
                    {e.tag}
                  </span>
                </div>
                <div className={`p-6 md:p-10 ${flip ? "md:order-1" : ""}`}>
                  <div className="flex items-center gap-2 text-xs text-foreground-500">
                    <span className="inline-flex items-center gap-1.5">
                      <i className="ri-edit-2-line text-primary-500" aria-hidden="true" />
                      {e.author}
                    </span>
                    <span aria-hidden="true">·</span>
                    <span className="inline-flex items-center gap-1.5">
                      <i className="ri-time-line" aria-hidden="true" />
                      预计 {e.readTime}
                    </span>
                  </div>
                  <h3 className="mt-4 font-heading text-2xl leading-snug font-semibold text-foreground-950 md:text-3xl">
                    {e.title}
                  </h3>
                  <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
                    {e.lead}
                  </p>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}